export const API_ENDPOINT_CHECK_INVOICE = `${process.env.REACT_APP_ASSET_API_URL}/check_invoice/`;
export const API_ENDPOINT_FETCH_INVOICE_HTML = `${process.env.REACT_APP_ASSET_API_URL}/get_invoice_html/`;
export const API_ENDPOINT_FETCH_INVOICE_DATA = `${process.env.REACT_APP_ASSET_API_URL}/get_invoice_data/`;
